import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Button } from '..'
import PlusIcon from '../icons/PlusIcon'
import { API_IMAGE_OBJECT } from '../../utils/types'
import useProgrammeList from '../../customHooks/useProgrammeList'
import styles from './styles'

const MyListButton = ({
  programme, addedStyles, color, programmeHead, addClass, page,
}) => {
  const emitterRef = useRef(null)
  const { inStore, handleClick } = useProgrammeList({ ...programme, emitterRef })
  const pluswidth = programmeHead ? 16 : 20
  const plusheight = programmeHead ? 16 : 20
  const tickwidth = programmeHead ? 24 : 20
  const tickheight = programmeHead ? 24 : 20
  return (
    <div className="my-list-button">
      {page === 'TvGuide' ? (
        <Button
          aria-label={inStore()
            ? `remove ${programme.name} from my list`
            : `add ${programme.name} to my list`}
          icon={inStore()
            ? PlusIcon({
              width: tickwidth, height: tickheight, title: 'Added To list', color, programmeHead, page,
            })
            : PlusIcon({
              width: pluswidth, height: plusheight, title: 'My list', color, programmeHead, page,
            })}
          text={inStore() ? 'Added to my list' : 'My list'}
          handleClick={handleClick()}
          capitalize
          className={programmeHead ? addClass : ''}
          variant={programmeHead ? '' : 'tertiary'}
          ref={emitterRef}
          style={addedStyles}
        />
      ) : (
        <Button
          aria-label={inStore()
            ? `remove ${programme.name} from my list`
            : `add ${programme.name} to my list`}
          icon={inStore()
            ? PlusIcon({
              width: tickwidth, height: tickheight, title: 'Added To list', color, programmeHead, page,
            })
            : PlusIcon({
              width: pluswidth, height: plusheight, title: 'My list', color, programmeHead, page,
            })}
          text={inStore() ? 'Added to my list' : 'My list'}
          handleClick={handleClick()}
          capitalize
          className={programmeHead ? addClass : ''}
          variant={programmeHead ? '' : 'tertiary'}
          ref={emitterRef}
          style={addedStyles}
        />
      )}

      <style jsx>{styles}</style>
    </div>
  )
}

MyListButton.propTypes = {
  programme: PropTypes.shape({
    name: PropTypes.string,
    programmeGuid: PropTypes.string,
    image: API_IMAGE_OBJECT,
  }),
  addedStyles: PropTypes.object,
  color: PropTypes.string,
  programmeHead: PropTypes.bool,
  addClass: PropTypes.string,
  page: PropTypes.string,
}

MyListButton.defaultProps = {
  programme: {
    name: '',
    programmeGuid: '',
    image: {},
  },
  addedStyles: {},
  color: '',
  programmeHead: false,
  addClass: '',
  page: '',
}

export default MyListButton
